var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { combineEpics } from 'redux-observable';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { AsyncRequestStatus, getCompletedAsyncWrapperObj, requestPendingOrCompleted, } from '@ane/core/lib/models';
import VivaceResoures from './VivaceResoures';
import { createAction } from 'typesafe-actions';
import _ from 'lodash';
import { mapIfDefined } from '@ane/core/lib/utils/CollectionUtils';
import { getWorkspaceIdSelector } from './Maui.selectors';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import NavigationService from '@ane/core/lib/services/NavigationService';
import { MetricsAuthoringRouteUtils } from '@ane/exp-data/lib/routes/MetricsAuthoringRoute.utils';
import { MAUIConfigurationPaths, MAUIDraftEntityPaths } from '../common/models/MAUI.models';
import { draftMetricsQueryStringEpics } from './VivaceUserContext.epics';
import { getDraftWorkspaceDictionaryKey } from '../common/components/CheckUserAccess/CheckUserAccess.selectors';
import { SetSubscribersEpicReducer, loadSubscribersEpicReducer } from '@ane/exp-ux/lib/components/Subscribers';
import { ENTITY_TYPES } from '@ane/exp-data/lib/models/SubscriberModels';
import { ComputationTypes, } from '../common/models/MDLComputations';
import { RestResult } from '@ane/core/lib/services/RestServiceBase';
import AnalysisResource from '@ane/exp-data/lib/resources/expapiv2/Analysis.resource';
import AnalysisResources from '@ane/summary-app-module/lib/module/views/Analysis/module/AnalysisResources';
import legacyExperimentResource from '@ane/exp-data/lib/resources/ExperimentResources';
import experimentUnifiedResource from '@ane/exp-data/lib/resources/expapiunified/Experiment.resource';
import FeatureResources from '@ane/exp-data/lib/resources/FeatureReadV2Resource';
import featureUnifiedResource from '@ane/exp-data/lib/resources/expapiunified/Feature.resource';
import { addOrUpdateMDLComputationFile } from '../common/utils/MDLComputations.utils';
import MetricServiceResource from '@ane/exp-data/lib/resources/MetricServiceResource';
import { PRODUCTION_BRANCH_ID } from '../constants/maui.constants';
import Logger from '@ane/core/lib/services/logging/Logger';
import { NewSegmentUITelemetryEventNames } from '../constants/NewSegmentUITelemetryEventNames';
export var ROOT_REDUCER_KEYS;
(function (ROOT_REDUCER_KEYS) {
    ROOT_REDUCER_KEYS["global"] = "global";
    ROOT_REDUCER_KEYS["metric_sets"] = "metric_sets";
    ROOT_REDUCER_KEYS["drafts"] = "drafts";
    ROOT_REDUCER_KEYS["draft"] = "draft";
})(ROOT_REDUCER_KEYS || (ROOT_REDUCER_KEYS = {}));
var GLOBAL_REDUCER_KEYS;
(function (GLOBAL_REDUCER_KEYS) {
    GLOBAL_REDUCER_KEYS["experimentation_groups_with_metric_write"] = "experimentation_groups_with_metric_write";
    GLOBAL_REDUCER_KEYS["experimentation_groups"] = "experimentation_groups";
    GLOBAL_REDUCER_KEYS["user_access"] = "user_access";
    GLOBAL_REDUCER_KEYS["user_metric_write_access"] = "user_metric_write_access";
})(GLOBAL_REDUCER_KEYS || (GLOBAL_REDUCER_KEYS = {}));
var METRIC_SETS_REDUCER_KEYS;
(function (METRIC_SETS_REDUCER_KEYS) {
    METRIC_SETS_REDUCER_KEYS["list"] = "list";
    METRIC_SETS_REDUCER_KEYS["create"] = "create";
    METRIC_SETS_REDUCER_KEYS["clone"] = "clone";
    METRIC_SETS_REDUCER_KEYS["delete"] = "delete";
    METRIC_SETS_REDUCER_KEYS["workspace_config"] = "workspace_config";
    METRIC_SETS_REDUCER_KEYS["metric_set_instance_create"] = "metric_set_instance_create";
    METRIC_SETS_REDUCER_KEYS["metric_set_instance_status"] = "metric_set_instance_status";
})(METRIC_SETS_REDUCER_KEYS || (METRIC_SETS_REDUCER_KEYS = {}));
var DRAFTS_REDUCER_KEYS;
(function (DRAFTS_REDUCER_KEYS) {
    DRAFTS_REDUCER_KEYS["meta_data"] = "meta_data";
    DRAFTS_REDUCER_KEYS["history"] = "history";
    DRAFTS_REDUCER_KEYS["list"] = "list";
    DRAFTS_REDUCER_KEYS["create"] = "create";
    DRAFTS_REDUCER_KEYS["delete"] = "delete";
    DRAFTS_REDUCER_KEYS["metric_set_config"] = "metric_set_config";
    DRAFTS_REDUCER_KEYS["metric_set_config_update"] = "metric_set_config_update";
    DRAFTS_REDUCER_KEYS["aggregation_levels"] = "aggregation_levels";
})(DRAFTS_REDUCER_KEYS || (DRAFTS_REDUCER_KEYS = {}));
export var DRAFT_REDUCER_KEYS;
(function (DRAFT_REDUCER_KEYS) {
    DRAFT_REDUCER_KEYS["history"] = "history";
    DRAFT_REDUCER_KEYS["raw_columns"] = "raw_columns";
    DRAFT_REDUCER_KEYS["aggregation_levels"] = "aggregation_levels";
    DRAFT_REDUCER_KEYS["experiment_config"] = "experiment_config";
    DRAFT_REDUCER_KEYS["meta_data"] = "meta_data";
    DRAFT_REDUCER_KEYS["scorecard_layouts"] = "scorecard_layouts";
    DRAFT_REDUCER_KEYS["computation_templates"] = "computation_templates";
    DRAFT_REDUCER_KEYS["computation_template_instances"] = "computation_template_instances";
    DRAFT_REDUCER_KEYS["computation_template_instance_metrics"] = "computation_template_instance_metrics";
    DRAFT_REDUCER_KEYS["scorecard_layout_paths"] = "scorecard_layout_paths";
    DRAFT_REDUCER_KEYS["merge"] = "merge";
    DRAFT_REDUCER_KEYS["merge_update"] = "merge_update";
    DRAFT_REDUCER_KEYS["validate"] = "validate";
    DRAFT_REDUCER_KEYS["validate_result"] = "validate_result";
    DRAFT_REDUCER_KEYS["metrics"] = "metrics";
    DRAFT_REDUCER_KEYS["metric_health"] = "metric_health";
    DRAFT_REDUCER_KEYS["publish"] = "publish";
    DRAFT_REDUCER_KEYS["publish_update"] = "publish_update";
    DRAFT_REDUCER_KEYS["publish_status"] = "publish_status";
    DRAFT_REDUCER_KEYS["published_versions"] = "published_versions";
    DRAFT_REDUCER_KEYS["recent_preview_analyses"] = "recent_preview_analyses";
    DRAFT_REDUCER_KEYS["experiment"] = "experiment";
    DRAFT_REDUCER_KEYS["recent_experiments"] = "recent_experiments";
    DRAFT_REDUCER_KEYS["feature_progressions"] = "feature_progressions";
    DRAFT_REDUCER_KEYS["recent_features"] = "recent_features";
    DRAFT_REDUCER_KEYS["default_experiments"] = "default_experiments";
    DRAFT_REDUCER_KEYS["default_features"] = "default_features";
    DRAFT_REDUCER_KEYS["experimentation_group_features"] = "experimentation_group_features";
    DRAFT_REDUCER_KEYS["experimentation_group_experiments"] = "experimentation_group_experiments";
    DRAFT_REDUCER_KEYS["experiment_plan_summaries"] = "experiment_plan_summaries";
    DRAFT_REDUCER_KEYS["experiment_steps_validate_result"] = "experiment_steps_validate_result";
    DRAFT_REDUCER_KEYS["segments"] = "segments";
    DRAFT_REDUCER_KEYS["computation_file_paths"] = "computation_file_paths";
    DRAFT_REDUCER_KEYS["columns"] = "columns";
    DRAFT_REDUCER_KEYS["quick_validate"] = "quick_validate";
})(DRAFT_REDUCER_KEYS || (DRAFT_REDUCER_KEYS = {}));
var SEGMENTS_REDUCER_KEYS;
(function (SEGMENTS_REDUCER_KEYS) {
    SEGMENTS_REDUCER_KEYS["list"] = "list";
    SEGMENTS_REDUCER_KEYS["load"] = "load";
    SEGMENTS_REDUCER_KEYS["create_get"] = "create_get";
    SEGMENTS_REDUCER_KEYS["create_put"] = "create_put";
    SEGMENTS_REDUCER_KEYS["delete"] = "delete";
})(SEGMENTS_REDUCER_KEYS || (SEGMENTS_REDUCER_KEYS = {}));
export var METRICS_REDUCER_KEYS;
(function (METRICS_REDUCER_KEYS) {
    METRICS_REDUCER_KEYS["list"] = "list";
    METRICS_REDUCER_KEYS["load"] = "load";
    METRICS_REDUCER_KEYS["create_get"] = "create_get";
    METRICS_REDUCER_KEYS["create_put"] = "create_put";
    METRICS_REDUCER_KEYS["delete"] = "delete";
})(METRICS_REDUCER_KEYS || (METRICS_REDUCER_KEYS = {}));
var COLUMN_REDUCER_KEYS;
(function (COLUMN_REDUCER_KEYS) {
    COLUMN_REDUCER_KEYS["list"] = "list";
    COLUMN_REDUCER_KEYS["load"] = "load";
})(COLUMN_REDUCER_KEYS || (COLUMN_REDUCER_KEYS = {}));
var METRIC_HEALTH_REDUCER_KEYS;
(function (METRIC_HEALTH_REDUCER_KEYS) {
    METRIC_HEALTH_REDUCER_KEYS["stat_sig_check"] = "stat_sig_check";
})(METRIC_HEALTH_REDUCER_KEYS || (METRIC_HEALTH_REDUCER_KEYS = {}));
export const REDUCER_KEYS = {
    [ROOT_REDUCER_KEYS.global]: {
        experimentation_groups_with_metric_write: 'experimentation_groups_with_metric_write',
        experimentation_groups: 'experimentation_groups',
        user_metric_write_access: 'user_metric_write_access',
    },
    [ROOT_REDUCER_KEYS.metric_sets]: {
        list: 'list',
        create: 'create',
        clone: 'clone',
        delete: 'delete',
        workspace_config: 'workspace_config',
        metric_set_instance_create: 'metric_set_instance_create',
        metric_set_instance_status: 'metric_set_instance_status',
    },
    [ROOT_REDUCER_KEYS.drafts]: {
        meta_data: 'meta_data',
        history: 'history',
        list: 'list',
        create: 'create',
        delete: 'delete',
        metric_set_config: 'metric_set_config',
        metric_set_config_update: 'metric_set_config_update',
        aggregation_levels: 'aggregation_levels',
    },
    [ROOT_REDUCER_KEYS.draft]: {
        history: 'history',
        raw_columns: 'raw_columns',
        aggregation_levels: 'aggregation_levels',
        experiment_config: 'experiment_config',
        meta_data: 'meta_data',
        scorecard_layouts: 'scorecard_layouts',
        computation_templates: 'computation_templates',
        computation_template_instances: 'computation_template_instances',
        computation_template_instance_metrics: 'computation_template_instance_metrics',
        scorecard_layout_paths: 'scorecard_layout_paths',
        merge: 'merge',
        merge_update: 'merge_update',
        validate: 'validate',
        validate_result: 'validate_result',
        metrics: {
            user_context: {
                metric: 'metric',
                query: 'query',
            },
            metric_wizard: 'metric_wizard',
            create_get: 'create_get',
            create_put: 'create_put',
            list: 'list',
            quick_compile_put: 'quick_compile_put',
            quick_compute_put: 'quick_compute_put',
            quick_compute_get: 'quick_compute_get',
            quick_compute_cancel: 'quick_compute_cancel',
            quick_compute_check: 'quick_compute_check',
            datasource_get: 'datasource_get',
            datasource_details_get: 'datasource_details_get',
        },
        metric_health: 'metric_health',
        publish: 'publish',
        publish_update: 'publish_update',
        publish_status: 'publish_status',
        published_versions: 'published_versions',
        recent_preview_analyses: 'recent_preview_analyses',
        experiment: 'experiment',
        recent_experiments: 'recent_experiments',
        feature_progressions: 'feature_progressions',
        recent_features: 'recent_features',
        default_experiments: 'default_experiments',
        default_features: 'default_features',
        experimentation_group_features: 'experimentation_group_features',
        experimentation_group_experiments: 'experimentation_group_experiments',
        experiment_plan_summaries: 'experiment_plan_summaries',
        experiment_steps_validate_result: 'experiment_steps_validate_result',
        segments: 'segments',
        computation_file_paths: 'computation_file_paths',
        columns: 'columns',
    },
};
const ACTION_PREFIX = 'METRICS_AUTHORING';
const ACTION_PREFIXES = {
    GLOBAL: `${ACTION_PREFIX}/GLOBAL`,
    METRIC_SETS: `${ACTION_PREFIX}/METRIC_SETS`,
    DRAFTS: `${ACTION_PREFIX}/DRAFTS`,
    DRAFT: `${ACTION_PREFIX}/DRAFT`,
};
export const ACTION_TYPES = {
    GLOBAL: {
        EXPERIMENTATION_GROUPS_WITH_METRICS_WRITE: `${ACTION_PREFIXES.GLOBAL}/EXPERIMENTATION_GROUPS_WITH_METRICS_WRITE`,
        EXPERIMENTATION_GROUPS: `${ACTION_PREFIXES.GLOBAL}/EXPERIMENTATION_GROUPS`,
        CHECK_USER_METRIC_WRITE_ACCESS: `${ACTION_PREFIXES.GLOBAL}/CHECK_USER_METRIC_WRITE_ACCESS`,
    },
    METRIC_SETS: {
        LIST: `${ACTION_PREFIXES.METRIC_SETS}/LIST`,
        CREATE: `${ACTION_PREFIXES.METRIC_SETS}/CREATE`,
        RESET_CREATE: `${ACTION_PREFIXES.METRIC_SETS}/RESET_CREATE`,
        CLONE: `${ACTION_PREFIXES.METRIC_SETS}/CLONE`,
        RESET_CLONE: `${ACTION_PREFIXES.METRIC_SETS}/RESET_CLONE`,
        DELETE: `${ACTION_PREFIXES.METRIC_SETS}/DELETE`,
        RESET_DELETE: `${ACTION_PREFIXES.METRIC_SETS}/RESET_DELETE`,
        REMOVE: `${ACTION_PREFIXES.METRIC_SETS}/REMOVE`,
        WORKSPACE_CONFIG: `${ACTION_PREFIXES.METRIC_SETS}/WORKSPACE_CONFIG`,
        METRIC_SET_INSTANCE_CREATE: `${ACTION_PREFIXES.METRIC_SETS}/METRIC_SET_INSTANCE_CREATE`,
        METRIC_SET_INSTANCE_STATUS: `${ACTION_PREFIXES.METRIC_SETS}/METRIC_SET_INSTANCE_STATUS`,
    },
    DRAFTS: {
        HISTORY: `${ACTION_PREFIXES.DRAFTS}/HISTORY`,
        RESET_HISTORY: `${ACTION_PREFIXES.DRAFTS}/RESET_HISTORY`,
        META_DATA: `${ACTION_PREFIXES.DRAFTS}/META_DATA`,
        RESET_META_DATA: `${ACTION_PREFIXES.DRAFTS}/RESET_META_DATA`,
        LIST: `${ACTION_PREFIXES.DRAFTS}/LIST`,
        CREATE: `${ACTION_PREFIXES.DRAFTS}CREATE`,
        RESET_CREATE: `${ACTION_PREFIXES.DRAFTS}/RESET_CREATE`,
        DELETE: `${ACTION_PREFIXES.DRAFTS}/DELETE`,
        RESET_DELETE: `${ACTION_PREFIXES.DRAFTS}/RESET_DELETE`,
        REMOVE: `${ACTION_PREFIXES.DRAFTS}/REMOVE`,
        METRIC_SET_CONFIG: `${ACTION_PREFIXES.DRAFTS}/METRIC_SET_CONFIG`,
        METRIC_SET_CONFIG_UPDATE: `${ACTION_PREFIXES.DRAFTS}/METRIC_SET_CONFIG_UPDATE`,
        AGGREGATION_LEVELS: `${ACTION_PREFIXES.DRAFTS}/AGGREGATION_LEVELS`,
    },
    DRAFT: {
        HISTORY: `${ACTION_PREFIXES.DRAFT}/HISTORY`,
        RESET_HISTORY: `${ACTION_PREFIXES.DRAFT}/RESET_HISTORY`,
        META_DATA: `${ACTION_PREFIXES.DRAFT}/META_DATA`,
        RAW_COLUMNS: `${ACTION_PREFIXES.DRAFT}/RAW_COLUMNS`,
        AGGREGATION_LEVELS: `${ACTION_PREFIXES.DRAFT}/AGGREGATION_LEVELS`,
        EXPERIMENT_CONFIG: `${ACTION_PREFIXES.DRAFT}/EXPERIMENT_CONFIG`,
        SCORECARD_LAYOUTS: `${ACTION_PREFIXES.DRAFT}/SCORECARD_LAYOUTS`,
        COMPUTATION_TEMPLATES: `${ACTION_PREFIXES.DRAFT}/COMPUTATION_TEMPLATES`,
        COMPUTATION_TEMPLATE_INSTANCES: `${ACTION_PREFIXES.DRAFT}/COMPUTATION_TEMPLATE_INSTANCES`,
        COMPUTATION_TEMPLATE_INSTANCE_METRICS: `${ACTION_PREFIXES.DRAFT}/COMPUTATION_TEMPLATE_INSTANCE_METRICS`,
        MERGE: `${ACTION_PREFIXES.DRAFT}/MERGE`,
        RESET_MERGE: `${ACTION_PREFIXES.DRAFT}/RESET_MERGE`,
        UPDATE_MERGE: `${ACTION_PREFIXES.DRAFT}/UPDATE_MERGE`,
        VALIDATE: `${ACTION_PREFIXES.DRAFT}/VALIDATE`,
        VALIDATE_RESULT: `${ACTION_PREFIXES.DRAFT}/VALIDATE_RESULT`,
        RESET_VALIDATE: `${ACTION_PREFIXES.DRAFT}/RESET_VALIDATE`,
        METRICS_HEALTH_STAT_SIG: `${ACTION_PREFIXES.DRAFT}/METRICS_HEALTH_STAT_SIG`,
        PUBLISH: `${ACTION_PREFIXES.DRAFT}/PUBLISH`,
        UPDATE_PUBLISH: `${ACTION_PREFIXES.DRAFT}/UPDATE_PUBLISH`,
        PUBLISH_STATUS: `${ACTION_PREFIXES.DRAFT}/PUBLISH_STATUS`,
        RESET_PUBLISH: `${ACTION_PREFIXES.DRAFT}/RESET_PUBLISH`,
        PUBLISHED_VERSIONS: `${ACTION_PREFIXES.DRAFT}/PUBLISHED_VERSIONS`,
        RECENT_PREVIEW_ANALYSES: `${ACTION_PREFIXES.DRAFT}/RECENT_PREVIEW_ANALYSES`,
        EXPERIMENT: `${ACTION_PREFIXES.DRAFT}/EXPERIMENT`,
        RECENT_EXPERIMENTS: `${ACTION_PREFIXES.DRAFT}/RECENT_EXPERIMENTS`,
        FEATURE_PROGRESSIONS: `${ACTION_PREFIXES.DRAFT}/FEATURE_PROGRESSIONS`,
        RECENT_FEATURES: `${ACTION_PREFIXES.DRAFT}/RECENT_FEATURES`,
        DEFAULT_EXPERIMENTS: `${ACTION_PREFIXES.DRAFT}/DEFAULT_EXPERIMENTS`,
        DEFAULT_FEATURES: `${ACTION_PREFIXES.DRAFT}/DEFAULT_FEATURES`,
        EXPERIMENTATION_GROUP_FEATURES: `${ACTION_PREFIXES.DRAFT}/EXPERIMENTATION_GROUP_FEATURES`,
        EXPERIMENTATION_GROUP_EXPERIMENTS: `${ACTION_PREFIXES.DRAFT}/EXPERIMENTATION_GROUP_EXPERIMENTS`,
        EXPERIMENT_STEP_PLAN_SUMMARIES: `${ACTION_PREFIXES.DRAFT}/EXPERIMENT_STEP_PLAN_SUMMARIES`,
        VALIDATE_EXPERIMENT_STEPS: `${ACTION_PREFIXES.DRAFT}/VALIDATE_EXPERIMENT_STEPS`,
        SEGMENTS_LIST: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_LIST`,
        SEGMENTS_LOAD: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_LOAD`,
        SEGMENTS_CREATE_GET: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_CREATE_GET`,
        SEGMENTS_CREATE_PUT: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_CREATE_PUT`,
        SEGMENTS_ADD: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_CREATE_ADD`,
        SEGMENTS_RESET_CREATE: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_RESET_CREATE`,
        SEGMENTS_DELETE: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_DELETE`,
        SEGMENTS_REMOVE: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_REMOVE`,
        SEGMENTS_RESET_DELETE: `${ACTION_PREFIXES.DRAFT}/SEGMENTS_RESET_DELETE`,
        COMPUTATION_FILE_PATHS: `${ACTION_PREFIXES.DRAFT}/COMPUTATION_FILE_PATHS`,
        COLUMNS: `${ACTION_PREFIXES.DRAFT}/COLUMNS`,
        COLUMN_DETAILS: `${ACTION_PREFIXES.DRAFT}/COLUMN_DETAILS`,
        METRICS_LIST: `${ACTION_PREFIXES.DRAFT}/METRICS`,
    },
};
const loadExperimentationGroupsWithMetricWriteEpicReducerArg = {
    actionPrefix: ACTION_TYPES.GLOBAL.EXPERIMENTATION_GROUPS_WITH_METRICS_WRITE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.global, REDUCER_KEYS.global.experimentation_groups_with_metric_write],
    loadResource: (inputPayload, state) => VivaceResoures.getExperimentationGroups({
        workspaceId: getWorkspaceIdSelector(state),
        metricWrite: true,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadExperimentationGroupsWithMetricWriteEpicReducer = loadResourcesUtils(loadExperimentationGroupsWithMetricWriteEpicReducerArg);
const loadAllExperimentationGroupsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.GLOBAL.EXPERIMENTATION_GROUPS_WITH_METRICS_WRITE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.global, REDUCER_KEYS.global.experimentation_groups],
    loadResource: (inputPayload, state) => VivaceResoures.getExperimentationGroups({
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadAllExperimentationGroupsEpicReducer = loadResourcesUtils(loadAllExperimentationGroupsEpicReducerArg);
export const resetCreateMetricSetState = createAction(ACTION_TYPES.METRIC_SETS.RESET_CREATE, (action) => () => action());
const createMetricSetEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_SETS.CREATE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.metric_sets, REDUCER_KEYS.metric_sets.create],
    loadResource: ({ metricSetName, experimentationGroup }, state) => VivaceResoures.createMetricSet({
        metricSetName,
        experimentationGroup,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        var _a, _b;
        const draftName = `${(_a = EnvironmentService.getUser()) === null || _a === void 0 ? void 0 : _a.alias}_draft`;
        return [
            createMetricSetDraftEpicReducer.actionCreators.load({
                metricSetName: inputPayload.metricSetName,
                draftName,
                setupDraft: true,
            }),
            SetSubscribersEpicReducer.actionCreators.load({
                workspaceId: getWorkspaceIdSelector(state),
                entityType: ENTITY_TYPES.METRICSET,
                entityExternalId: inputPayload.metricSetName,
                entityIsNew: true,
                subscriberBaseInfoList: ((_b = inputPayload.subscribers) === null || _b === void 0 ? void 0 : _b.map((s) => !!s.id ? { id: s.id, type: s.type || '', tenantId: s.tenantId } : { id: s.primaryText, type: 'Email' })) || [],
            }),
            loadMetricSetsEpicReducer.actionCreators.load({ refresh: true }),
        ];
    },
};
export const createMetricSetEpicReducer = loadResourcesUtils(createMetricSetEpicReducerArg);
export const resetCloneMetricSetState = createAction(ACTION_TYPES.METRIC_SETS.RESET_CLONE, (action) => () => action());
const cloneMetricSetEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_SETS.CLONE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.metric_sets, REDUCER_KEYS.metric_sets.clone],
    loadResource: ({ metricSetName, sourceMetricSetName, experimentationGroup }, state) => VivaceResoures.cloneMetricSet({
        metricSetName,
        sourceMetricSetName,
        experimentationGroup,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: ({ metricSetName, subscribers }, outputPayload, state) => {
        NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.viewDrafts.url({
            metricSetName,
        }));
        return [
            resetCloneMetricSetState(),
            SetSubscribersEpicReducer.actionCreators.load({
                workspaceId: getWorkspaceIdSelector(state),
                entityType: ENTITY_TYPES.METRICSET,
                entityExternalId: metricSetName,
                entityIsNew: true,
                subscriberBaseInfoList: (subscribers === null || subscribers === void 0 ? void 0 : subscribers.map((s) => !!s.id ? { id: s.id, type: s.type || '', tenantId: s.tenantId } : { id: s.primaryText, type: 'Email' })) || [],
            }),
        ];
    },
};
export const cloneMetricSetEpicReducer = loadResourcesUtils(cloneMetricSetEpicReducerArg);
export const removeMetricSetFromList = createAction(ACTION_TYPES.METRIC_SETS.REMOVE, (action) => (metricSetName) => action(metricSetName));
export const resetDeleteMetricSetState = createAction(ACTION_TYPES.METRIC_SETS.RESET_DELETE, (action) => () => action());
const deleteMetricSetEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_SETS.DELETE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.metric_sets, REDUCER_KEYS.metric_sets.delete],
    loadResource: ({ metricSetName }, state) => VivaceResoures.deleteMetricSet({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload) => [
        removeMetricSetFromList(inputPayload.metricSetName),
    ],
};
export const deleteMetricSetEpicReducer = loadResourcesUtils(deleteMetricSetEpicReducerArg);
const loadMetricSetsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_SETS.LIST,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.metric_sets, REDUCER_KEYS.metric_sets.list],
    loadResource: (inputPayload, state) => MetricServiceResource.getMetricSets({
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    dontLoad: (payload, state) => {
        if (payload === null || payload === void 0 ? void 0 : payload.refresh) {
            return false;
        }
        return requestPendingOrCompleted(state.maui[ROOT_REDUCER_KEYS.metric_sets].list.status);
    },
};
export const loadMetricSetsEpicReducer = loadResourcesUtils(loadMetricSetsEpicReducerArg);
const loadProductionDraftEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFTS.META_DATA,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.drafts, REDUCER_KEYS.drafts.meta_data],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftMetadata({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadProductionMetaDataEpicReducer = loadResourcesUtils(loadProductionDraftEpicReducerArg);
export const resetProductionDraftMetaDataState = createAction(ACTION_TYPES.DRAFTS.RESET_META_DATA, (action) => () => action());
const loadProductionDraftHistoryEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFTS.HISTORY,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.drafts, REDUCER_KEYS.drafts.history],
    loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetHistory({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadProductionHistoryEpicReducer = loadResourcesUtils(loadProductionDraftHistoryEpicReducerArg);
export const resetProductionDraftHistoryState = createAction(ACTION_TYPES.DRAFTS.RESET_HISTORY, (action) => () => action());
const loadMetricSetDraftsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFTS.LIST,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.drafts, REDUCER_KEYS.drafts.list],
    loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetDrafts({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadMetricSetDraftsEpicReducer = loadResourcesUtils(loadMetricSetDraftsEpicReducerArg);
const loadMetricSetDraftMetadataEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.META_DATA,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.meta_data],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftMetadata({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadMetricSetDraftMetadataEpicReducer = loadResourcesUtils(loadMetricSetDraftMetadataEpicReducerArg);
const loadMetricSetDraftHistoryEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.HISTORY,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.history],
    loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetHistory({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadMetricSetDraftHistoryEpicReducer = loadResourcesUtils(loadMetricSetDraftHistoryEpicReducerArg);
export const resetMetricSetDraftHistoryState = createAction(ACTION_TYPES.DRAFT.RESET_HISTORY, (action) => () => action());
const loadMetricSetDraftRawColumnsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.RAW_COLUMNS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.raw_columns],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftRawColumns({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => {
        var _a, _b;
        // adapted from vivace - src\app\common\metric-set\raw-columns.model.js
        const namespaceNode = (_b = (_a = resourceResult.Mdl) === null || _a === void 0 ? void 0 : _a.Namespaces) === null || _b === void 0 ? void 0 : _b.Namespace;
        const namespaceList = Array.isArray(namespaceNode)
            ? namespaceNode
            : namespaceNode
                ? [namespaceNode]
                : [];
        const allRawColumns = namespaceList.map((namespace) => {
            const tableNode = namespace.Tables.Table;
            const tablesList = Array.isArray(tableNode) ? tableNode : tableNode ? [tableNode] : [];
            const columnsFromTables = tablesList.map((table) => {
                const columnsList = table.Columns ? table.Columns.i : null;
                if (columnsList && Array.isArray(columnsList)) {
                    // new RawColumn(rawColumn, namespace['@Name']
                    return (columnsList || []).map((rawColumnApiResponse) => {
                        // adapted from vivace - \src\app\common\metric-set\raw-column.model.js
                        const rawColumn = {
                            name: rawColumnApiResponse['@Name'],
                            type: rawColumnApiResponse['@Type'],
                            isPublic: rawColumnApiResponse['@IsPublic'] === 'true',
                            namespace: namespace['@Name'],
                        };
                        return rawColumn;
                    });
                }
                else if (columnsList) {
                    /**
                     * If the column list is not an array, we return the value of table.Columns.i as the first index in an array
                     * No previous development notes, see:
                     * https://experimentation.visualstudio.com/Analysis%20and%20Experimentation/_git/AnE.Exp.MetricService?path=/src/WebClient/src/app/common/metric-set/raw-columns.model.js&version=GBmaster&line=19&lineEnd=19&lineStartColumn=11&lineEndColumn=42&lineStyle=plain&_a=contents
                     */
                    return [columnsList];
                }
                else {
                    /**
                     * Fallback to an empty array, see:
                     * https://experimentation.visualstudio.com/Analysis%20and%20Experimentation/_git/AnE.Exp.MetricService?path=/src/WebClient/src/app/common/metric-set/raw-columns.model.js&version=GBmaster&line=7&lineEnd=7&lineStartColumn=5&lineEndColumn=23&lineStyle=plain&_a=contents
                     */
                    return [];
                }
            });
            return columnsFromTables;
        });
        const rawColumns = _.flatMapDeep(allRawColumns);
        return rawColumns || [];
    },
};
export const loadMetricSetDraftRawColumnsEpicReducer = loadResourcesUtils(loadMetricSetDraftRawColumnsEpicReducerArg);
//---
const loadMetricSetDraftAggregationLevelsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.AGGREGATION_LEVELS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.aggregation_levels],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftAggregationLevels({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => {
        // adapted from vivace - \src\app\common\metric-set\aggregation-level.model.js
        const namespaceNode = resourceResult.Mdl.Namespaces.Namespace;
        const namespaceList = Array.isArray(namespaceNode)
            ? namespaceNode
            : namespaceNode
                ? [namespaceNode]
                : [];
        const allAggregationLevels = mapIfDefined(namespaceList, (namespace) => {
            const tables = namespace.Tables.Table;
            if (tables) {
                const tableArray = Array.isArray(tables) ? tables : [tables];
                const currentGroupByColumns = (tableArray || []).map((column) => {
                    // adapted from vivace - \src\app\common\metric-set\groupby-column.model.js
                    // TODO: find out more...this is my best guess (same for groupByColumn)
                    // I'm not sure if column.SourceTable is a string when it is not an object, or the object does not have the '#text' property
                    const sourceTable = typeof column.SourceTable === 'object' && '#text' in column.SourceTable
                        ? column.SourceTable['#text']
                        : column.SourceTable;
                    const groupByColumn = column.GroupByColumn && typeof column.GroupByColumn === 'object' && '#text' in column.GroupByColumn
                        ? column.GroupByColumn['#text']
                        : column.GroupByColumn;
                    const aggregationLevel = {
                        namespace: namespace['@Name'],
                        name: column['@Name'],
                        sourceTable,
                        groupByColumn,
                    };
                    return aggregationLevel;
                });
                return currentGroupByColumns;
            }
        });
        const aggregationLevels = _.flatMapDeep(allAggregationLevels);
        return aggregationLevels || [];
    },
};
export const loadMetricSetDraftAggregationLevelsEpicReducer = loadResourcesUtils(loadMetricSetDraftAggregationLevelsEpicReducerArg);
//---
const loadMetricSetDraftExperimentationConfigEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENT_CONFIG,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.experiment_config],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMetricSetDraftExperimentationConfig({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => {
        // vivace has custom logic to "clean up" the data, but the fields (seem) to be the same
        // TODO, add this logic (from vivace - \src\app\common\metric-set\exp-config.model.js)
        return resourceResult;
    },
};
export const loadMetricSetDraftExperimentationConfigEpicReducer = loadResourcesUtils(loadMetricSetDraftExperimentationConfigEpicReducerArg);
/**
 * Load scorecard layouts
 */
const loadScorecardLayoutsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.SCORECARD_LAYOUTS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.scorecard_layouts],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getScorecardLayouts({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
};
export const loadScorecardLayoutsEpicReducer = loadResourcesUtils(loadScorecardLayoutsEpicReducerArg);
/**
 * Load computation templates
 */
const loadComputationTemplatesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.COMPUTATION_TEMPLATES,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.computation_templates],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getComputationTemplates({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => {
        return resourceResult.map((item) => {
            var _a, _b;
            if (((_b = (_a = item.i) === null || _a === void 0 ? void 0 : _a.TemplateParameters) === null || _b === void 0 ? void 0 : _b.TemplateParameter) && !Array.isArray(item.i.TemplateParameters.TemplateParameter)) {
                item.i.TemplateParameters.TemplateParameter = [item.i.TemplateParameters.TemplateParameter];
            }
            return item;
        });
    },
};
export const loadComputationTemplatesEpicReducer = loadResourcesUtils(loadComputationTemplatesEpicReducerArg);
const loadComputationTemplateInstancesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.COMPUTATION_TEMPLATE_INSTANCES,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.computation_template_instances],
    loadResource: ({ metricSetName, draftName, templateName }, state) => VivaceResoures.getComputationTemplateInstances({
        metricSetName,
        draftName,
        templateName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
};
export const loadComputationTemplateInstancesEpicReducer = loadResourcesUtils(loadComputationTemplateInstancesEpicReducerArg);
const loadMetricsForCompuatationTemplateInstancesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.COMPUTATION_TEMPLATE_INSTANCE_METRICS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.computation_template_instance_metrics],
    loadResource: ({ metricSetName, draftName, templateName }, state) => VivaceResoures.getMetricsForTemplateInstance({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName,
        draftName,
        templateName,
    }),
    onCompleteSuccess: (resourceResult, payload) => {
        if (!resourceResult) {
            return [];
        }
        return resourceResult.filter((metric) => metric.i['@InstanceId'] === payload.instanceId);
    },
};
export const loadMetricsForCompuatationTemplateInstancesEpicReducer = loadResourcesUtils(loadMetricsForCompuatationTemplateInstancesEpicReducerArg);
export const resetCreateMetricSetDraftState = createAction(ACTION_TYPES.DRAFTS.RESET_CREATE, (action) => () => action());
const createMetricSetDraftEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFTS.CREATE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.drafts, REDUCER_KEYS.drafts.create],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.createDraft({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnFailure({ metricSetName, setupDraft }) {
        if (setupDraft) {
            return [loadMetricSetsEpicReducer.actionCreators.load({})];
        }
        return [];
    },
    afterActionsOnSuccess: ({ metricSetName, draftName, setupDraft }, outputPayload) => {
        if (setupDraft) {
            /**
             * TODO update MetricsAuthoringRouteUtils
             * use util to get default setup pathname
             */
            NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.metricSetup.url({
                metricSetName,
                draftName,
                view: MAUIConfigurationPaths['data-source'],
            }));
            /**
             * Used in create metric set workflow
             * Create metric set -> create draft
             *
             * The async status must be reset to re-open the create metric set panel
             */
            return [resetCreateMetricSetState(), resetCreateMetricSetDraftState()];
        }
        else {
            /**
             * We cannot determine if the draft is already setup
             */
            NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
                metricSetName,
                draftName,
                entityName: MAUIDraftEntityPaths.metric,
            }));
        }
        return [resetCreateMetricSetDraftState()];
    },
};
export const createMetricSetDraftEpicReducer = loadResourcesUtils(createMetricSetDraftEpicReducerArg);
export const removeDraftFromList = createAction(ACTION_TYPES.DRAFTS.REMOVE, (action) => (draftName) => action(draftName));
export const resetDeleteMetricSetDraftState = createAction(ACTION_TYPES.DRAFTS.RESET_DELETE, (action) => () => action());
const deleteMetricSetDraftEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFTS.DELETE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.drafts, REDUCER_KEYS.drafts.delete],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.deleteDraft({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload) => [
        removeDraftFromList(inputPayload.draftName),
    ],
};
export const deleteMetricSetDraftEpicReducer = loadResourcesUtils(deleteMetricSetDraftEpicReducerArg);
const mergeMetricSetDraftEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.MERGE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.merge],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.mergeMetricSetDraft({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
        draftName: draftName,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const mergeMetricSetDraftEpicReducer = loadResourcesUtils(mergeMetricSetDraftEpicReducerArg);
const updateMergeStatusMetricSetDraftEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.UPDATE_MERGE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.merge_update],
    loadResource: ({ metricSetName, draftName, mergeStatus }, state) => VivaceResoures.updateMergeStatus({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
        draftName: draftName,
        mergeStatus: mergeStatus,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const updateMergeStatusMetricSetDraftEpicReducer = loadResourcesUtils(updateMergeStatusMetricSetDraftEpicReducerArg);
export const resetMergeMetricSetDraftStateActionName = ACTION_TYPES.DRAFT.RESET_MERGE;
export const resetMergeMetricSetDraftState = createAction(resetMergeMetricSetDraftStateActionName, (action) => () => action());
const validateMetricSetDraftEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.VALIDATE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.validate],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.validateMetricSetDraft({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
        draftName,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    onLoaded: (resourceResult, payload, state) => ({
        isSuccessful: !!resourceResult && resourceResult.isSuccessful(),
        data: !!resourceResult && resourceResult.isSuccessful() ? resourceResult.getRawData() : null,
    }),
};
export const validateMetricSetDraftEpicReducer = loadResourcesUtils(validateMetricSetDraftEpicReducerArg);
export const resetValidateMetricSetDraftStateActionName = ACTION_TYPES.DRAFT.RESET_VALIDATE;
export const resetValidateMetricSetDraftState = createAction(resetValidateMetricSetDraftStateActionName, (action) => () => action());
const getValidateResultEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.VALIDATE_RESULT,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.validate_result],
    loadResource: ({ metricSetName, draftName, validationRequestId }, state) => VivaceResoures.getValidationResult({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
        draftName,
        requestId: validationRequestId,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const getValidateResultEpicReducer = loadResourcesUtils(getValidateResultEpicReducerArg);
const publishMetricSetDraftEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.PUBLISH,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.publish],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.publishMetricSetDraft({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
        draftName,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    onLoaded: (resourceResult, payload, state) => ({
        isSuccessful: !!resourceResult && resourceResult.isSuccessful(),
        data: !!resourceResult && resourceResult.isSuccessful() ? resourceResult.getRawData() : null,
    }),
};
export const publishMetricSetDraftEpicReducer = loadResourcesUtils(publishMetricSetDraftEpicReducerArg);
const updatePublishStatusMetricSetDraftEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.UPDATE_PUBLISH,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.publish_update],
    loadResource: ({ metricSetName, draftName, publishStatus }, state) => VivaceResoures.updatePublishStatus({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
        draftName: draftName,
        publishStatus: publishStatus,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const updatePublishStatusMetricSetDraftEpicReducer = loadResourcesUtils(updatePublishStatusMetricSetDraftEpicReducerArg);
export const resetPublishMetricSetDraftStateActionName = ACTION_TYPES.DRAFT.RESET_PUBLISH;
export const resetPublishMetricSetDraftState = createAction(resetPublishMetricSetDraftStateActionName, (action) => () => action());
const loadPublishStatusEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.PUBLISH_STATUS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.publish_status],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getPublishStatus({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName,
        draftName,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadPublishStatusEpicReducer = loadResourcesUtils(loadPublishStatusEpicReducerArg);
const loadPublishedVersionsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.PUBLISHED_VERSIONS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.published_versions],
    loadResource: ({ metricSetName, isDraft }, state) => VivaceResoures.getPublishedVersions({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName,
        isDraft,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadPublishedVersionsEpicReducer = loadResourcesUtils(loadPublishedVersionsEpicReducerArg);
const loadRecentPreviewAnalysisEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.RECENT_PREVIEW_ANALYSES,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.recent_preview_analyses],
    loadResource: ({ metricSetName }, state) => AnalysisResource.getPreviewAnalyses(getWorkspaceIdSelector(state), metricSetName),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => inputPayload.getExperimentSteps
        ? [
            loadRecentExperimentsEpicReducer.actionCreators.load({
                getFeatures: true,
                experimentIds: _.uniq(_.filter(outputPayload.value, (analysis) => !!analysis.experimentMetadata.experimentId &&
                    analysis.experimentMetadata.workspaceId === getWorkspaceIdSelector(state)).map((analysis) => analysis.experimentMetadata.experimentId)),
            }),
        ]
        : [],
};
export const loadRecentPreviewAnalysisEpicReducer = loadResourcesUtils(loadRecentPreviewAnalysisEpicReducerArg);
const loadExperimentEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENT,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.experiment],
    loadResource: ({ experimentId }, state) => experimentUnifiedResource.getExperimentRestResult(getWorkspaceIdSelector(state), experimentId),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadExperimentEpicReducer = loadResourcesUtils(loadExperimentEpicReducerArg);
const loadRecentExperimentsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.RECENT_EXPERIMENTS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.recent_experiments],
    loadResource: (_a, state_1) => __awaiter(void 0, [_a, state_1], void 0, function* ({ experimentIds }, state) {
        const experiments = yield Promise.all(_.map(experimentIds, (experimentId) => experimentUnifiedResource.getExperiment(getWorkspaceIdSelector(state), experimentId)));
        return RestResult.fromResult(experiments);
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => inputPayload.getFeatures
        ? [
            loadRecentFeaturesEpicReducer.actionCreators.load({
                featureIds: _.uniq(_.filter(outputPayload, (experiment) => experiment.featureId !== '00000000-0000-0000-0000-000000000000' && experiment.featureId !== experiment.id).map((experiment) => experiment.featureId)),
            }),
        ]
        : [],
};
export const loadRecentExperimentsEpicReducer = loadResourcesUtils(loadRecentExperimentsEpicReducerArg);
const loadFeatureProgressionsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.FEATURE_PROGRESSIONS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.feature_progressions],
    loadResource: ({ featureId }, state) => FeatureResources.loadProgressionsRestResult(featureId, false, true),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadFeatureProgressionsEpicReducer = loadResourcesUtils(loadFeatureProgressionsEpicReducerArg);
const loadRecentFeaturesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.RECENT_FEATURES,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.recent_features],
    loadResource: (_a, state_1) => __awaiter(void 0, [_a, state_1], void 0, function* ({ featureIds }, state) {
        const results = yield Promise.all(_.map(featureIds, (featureId) => featureUnifiedResource.getFeature(getWorkspaceIdSelector(state), featureId)));
        const features = _.map(results, (result) => result.getSuccessData());
        return RestResult.fromResult(features);
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadRecentFeaturesEpicReducer = loadResourcesUtils(loadRecentFeaturesEpicReducerArg);
const loadDefaultExperimentsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.DEFAULT_EXPERIMENTS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.default_experiments],
    loadResource: (_a, state_1) => __awaiter(void 0, [_a, state_1], void 0, function* ({ experimentIds }, state) {
        const experiments = yield Promise.all(_.map(experimentIds, (experimentId) => experimentUnifiedResource.getExperiment(getWorkspaceIdSelector(state), experimentId)));
        return RestResult.fromResult(experiments);
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => [
        loadDefaultFeaturesEpicReducer.actionCreators.load({
            featureIds: _.uniq(_.filter(outputPayload, (experiment) => experiment.featureId !== '00000000-0000-0000-0000-000000000000' && experiment.featureId !== experiment.id).map((experiment) => experiment.featureId)),
        }),
    ],
};
export const loadDefaultExperimentsEpicReducer = loadResourcesUtils(loadDefaultExperimentsEpicReducerArg);
const loadDefaultFeaturesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.DEFAULT_FEATURES,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.default_features],
    loadResource: (_a, state_1) => __awaiter(void 0, [_a, state_1], void 0, function* ({ featureIds }, state) {
        const results = yield Promise.all(_.map(featureIds, (featureId) => featureUnifiedResource.getFeature(getWorkspaceIdSelector(state), featureId)));
        const features = _.map(results, (result) => result.getSuccessData());
        return RestResult.fromResult(features);
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadDefaultFeaturesEpicReducer = loadResourcesUtils(loadDefaultFeaturesEpicReducerArg);
export const loadFeaturesForExperimentationGroupEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENTATION_GROUP_FEATURES,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.experimentation_group_features],
    loadResource: (payload) => featureUnifiedResource.getFeatures(payload.workspaceId, {
        experimentationGroup: payload.experimentationGroup,
        isArchived: false,
        top: EnvironmentService.previewScorecardSearchCountUnified(),
        skip: 0,
        onlyLoadFeatureData: true,
        collapseRolloutTargetsIntoRoot: true,
    }),
    onCompleteSuccess: (result) => (result ? result.value : []),
};
export const loadFeaturesForExperimentationGroupEpicReducer = loadResourcesUtils(loadFeaturesForExperimentationGroupEpicReducerArg);
export const loadExperimentsForExperimentationGroupEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENTATION_GROUP_EXPERIMENTS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.experimentation_group_experiments],
    loadResource: (payload) => {
        const address = `?workspaceId=${payload.workspaceId}&managementGroup=${payload.experimentationGroup}&CollapseRolloutTargetsIntoRoot=true&top=${EnvironmentService.previewScorecardSearchCountLegacy()}`;
        return legacyExperimentResource.getAllExperiments(address);
    },
    onCompleteSuccess: (result) => result.Results,
};
export const loadExperimentsForExperimentationGroupEpicReducer = loadResourcesUtils(loadExperimentsForExperimentationGroupEpicReducerArg);
export const loadExperimentStepPlanSummariesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.EXPERIMENT_STEP_PLAN_SUMMARIES,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.experiment_plan_summaries],
    loadResource: (_a, state_1) => __awaiter(void 0, [_a, state_1], void 0, function* ({ stepIds }, state) {
        const results = yield Promise.all(stepIds.map((stepId) => __awaiter(void 0, void 0, void 0, function* () {
            return { [stepId]: yield AnalysisResources.getExperimentStepPlanSummary(stepId) };
        })));
        const experimentStepPlans = results
            .filter((result) => Object.values(result)[0].isSuccessful())
            .map((successfulResult) => {
            return { [Object.keys(successfulResult)[0]]: Object.values(successfulResult)[0].getSuccessData() };
        });
        return RestResult.fromResult(experimentStepPlans);
    }),
    onCompleteSuccess: (result) => result,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => [
        loadDefaultExperimentsEpicReducer.actionCreators.load({
            experimentIds: _.uniq(outputPayload.map((experimentPlan) => Object.values(experimentPlan)[0].Id)),
        }),
    ],
};
export const loadExperimentStepPlanSummariesEpicReducer = loadResourcesUtils(loadExperimentStepPlanSummariesEpicReducerArg);
export const validateExperimentStepsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.VALIDATE_EXPERIMENT_STEPS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.experiment_steps_validate_result],
    loadResource: (payload) => __awaiter(void 0, void 0, void 0, function* () {
        const experimentStepPlanSummaries = yield Promise.all(_.map(payload.metricSetConfig.defaultExperimentStepsForPreviewScorecard, (stepId) => __awaiter(void 0, void 0, void 0, function* () {
            return { [stepId]: yield AnalysisResources.getExperimentStepPlanSummary(stepId) };
        })));
        const validationResults = _.map(experimentStepPlanSummaries, (experimentStepPlanSummary) => {
            const stepId = Object.keys(experimentStepPlanSummary)[0];
            const result = Object.values(experimentStepPlanSummary)[0];
            if (result.statusCode >= 400) {
                return { [stepId]: false };
            }
            else
                return { [stepId]: true };
        });
        return RestResult.fromResult(validationResults);
    }),
    onCompleteSuccess: (result) => result,
    afterActionsOnSuccess(inputPayload, outputPayload, state) {
        let inValidSteps = [];
        outputPayload.map((validationResult) => {
            if (Object.values(validationResult)[0] === false) {
                inValidSteps.push(Object.keys(validationResult)[0]);
            }
        });
        if (inValidSteps.length > 0) {
            return [];
        }
        return [
            updateMetricSetConfigEpicReducer.actionCreators.load({
                metricSetConfig: inputPayload.metricSetConfig,
            }),
        ];
    },
};
export const validateExperimentStepsEpicReducer = loadResourcesUtils(validateExperimentStepsEpicReducerArg);
const checkUserMetriCWriteAccessEpicReducerArg = {
    actionPrefix: ACTION_TYPES.GLOBAL.CHECK_USER_METRIC_WRITE_ACCESS,
    reduxKeyNested: ({ workspaceId, metricSetName, draftName }) => {
        const key = getDraftWorkspaceDictionaryKey({ workspaceId, metricSetName, draftName });
        return [ROOT_REDUCER_KEYS.global, REDUCER_KEYS.global.user_metric_write_access, key];
    },
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getUserMetricWriteAccess({
        metricSetName,
        workspaceId: getWorkspaceIdSelector(state),
        draftName: draftName,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    dontLoad: ({ workspaceId, metricSetName, draftName }, state) => {
        var _a;
        const key = getDraftWorkspaceDictionaryKey({ workspaceId, metricSetName, draftName });
        return ((_a = state.maui.global.user_metric_write_access[key]) === null || _a === void 0 ? void 0 : _a.status) === AsyncRequestStatus.Completed;
    },
};
export const checkUserMetricWriteAccessEpicReducer = loadResourcesUtils(checkUserMetriCWriteAccessEpicReducerArg);
const loadMetricSetConfigEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFTS.METRIC_SET_CONFIG,
    reduxKeyNested: () => {
        return [ROOT_REDUCER_KEYS.drafts, REDUCER_KEYS.drafts.metric_set_config];
    },
    loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetConfig({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadMetricSetConfigEpicReducer = loadResourcesUtils(loadMetricSetConfigEpicReducerArg);
const updateMetricSetConfigEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFTS.METRIC_SET_CONFIG_UPDATE,
    reduxKeyNested: () => {
        return [ROOT_REDUCER_KEYS.drafts, REDUCER_KEYS.drafts.metric_set_config_update];
    },
    loadResource: ({ metricSetConfig }, state) => {
        metricSetConfig.workspace = getWorkspaceIdSelector(state);
        return VivaceResoures.putMetricSetConfig({
            workspaceId: metricSetConfig.workspace,
            request: metricSetConfig,
        });
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        return [
            loadMetricSetConfigEpicReducer.actionCreators.loaded({
                metricSetName: inputPayload.metricSetConfig.metricSet,
            }, getCompletedAsyncWrapperObj(inputPayload.metricSetConfig)),
        ];
    },
};
export const updateMetricSetConfigEpicReducer = loadResourcesUtils(updateMetricSetConfigEpicReducerArg);
const createMetricSetInstanceEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_SETS.METRIC_SET_INSTANCE_CREATE,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.metric_sets, REDUCER_KEYS.metric_sets.metric_set_instance_create],
    loadResource: (request, state) => {
        return VivaceResoures.postMetricSetInstance({
            workspaceId: getWorkspaceIdSelector(state),
            request,
        });
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const createMetricSetInstanceEpicReducer = loadResourcesUtils(createMetricSetInstanceEpicReducerArg);
const loadMetricSetInstanceStatusEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_SETS.METRIC_SET_INSTANCE_STATUS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.metric_sets, REDUCER_KEYS.metric_sets.metric_set_instance_status],
    loadResource: (payload, state) => {
        return VivaceResoures.getMetricSetInstanceCreateStatus({
            workspaceId: getWorkspaceIdSelector(state),
            metricSetName: payload.metricSetName,
            operationId: payload.operationId,
        });
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadMetricSetInstanceStatusEpicReducer = loadResourcesUtils(loadMetricSetInstanceStatusEpicReducerArg);
const loadWorkspaceConfigEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_SETS.WORKSPACE_CONFIG,
    reduxKeyNested: () => {
        return [ROOT_REDUCER_KEYS.metric_sets, REDUCER_KEYS.metric_sets.workspace_config];
    },
    loadResource: (_, state) => VivaceResoures.getWorkspaceConfig({
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadWorkspaceConfigEpicReducer = loadResourcesUtils(loadWorkspaceConfigEpicReducerArg);
const loadMetricSetMainAggregationLevelsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFTS.AGGREGATION_LEVELS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.drafts, REDUCER_KEYS.drafts.aggregation_levels],
    loadResource: ({ metricSetName }, state) => VivaceResoures.getMetricSetDraftAggregationLevels({
        metricSetName,
        draftName: PRODUCTION_BRANCH_ID,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => {
        // adapted from vivace - \src\app\common\metric-set\aggregation-level.model.js
        if (!resourceResult || !resourceResult.Mdl) {
            return [];
        }
        const namespaceNode = resourceResult.Mdl.Namespaces.Namespace;
        const namespaceList = Array.isArray(namespaceNode)
            ? namespaceNode
            : namespaceNode
                ? [namespaceNode]
                : [];
        const allAggregationLevels = mapIfDefined(namespaceList, (namespace) => {
            const tables = namespace.Tables.Table;
            if (tables) {
                const tableArray = Array.isArray(tables) ? tables : [tables];
                const currentGroupByColumns = (tableArray || []).map((column) => {
                    // adapted from vivace - \src\app\common\metric-set\groupby-column.model.js
                    // TODO: find out more...this is my best guess (same for groupByColumn)
                    // I'm not sure if column.SourceTable is a string when it is not an object, or the object does not have the '#text' property
                    const sourceTable = typeof column.SourceTable === 'object' && '#text' in column.SourceTable
                        ? column.SourceTable['#text']
                        : column.SourceTable;
                    const groupByColumn = column.GroupByColumn && typeof column.GroupByColumn === 'object' && '#text' in column.GroupByColumn
                        ? column.GroupByColumn['#text']
                        : column.GroupByColumn;
                    const aggregationLevel = {
                        namespace: namespace['@Name'],
                        name: column['@Name'],
                        sourceTable,
                        groupByColumn,
                    };
                    return aggregationLevel;
                });
                return currentGroupByColumns;
            }
        });
        const aggregationLevels = _.flatMapDeep(allAggregationLevels);
        return aggregationLevels || [];
    },
    onLoaded: (response) => {
        if (!!response && response.statusCode === 404) {
            return { data: {}, isSuccessful: true };
        }
        return undefined;
    },
};
export const loadMetricSetMainAggregationLevelsEpicReducer = loadResourcesUtils(loadMetricSetMainAggregationLevelsEpicReducerArg);
//define epic for health check
const loadMetricHealthResultsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.METRICS_HEALTH_STAT_SIG,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.metric_health, METRIC_HEALTH_REDUCER_KEYS.stat_sig_check],
    loadResource: (payload, state) => VivaceResoures.getHealthCheck(payload),
    onCompleteSuccess: (result) => result,
};
export const loadMetricHealthResultsEpicReducer = loadResourcesUtils(loadMetricHealthResultsEpicReducerArg);
const loadComputationFilePathsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.COMPUTATION_FILE_PATHS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.computation_file_paths],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getMDLComputationFiles({
        metricSetName,
        draftName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (result) => result,
};
export const loadComputationFilePathsEpicReducer = loadResourcesUtils(loadComputationFilePathsEpicReducerArg);
const loadColumnsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.COLUMNS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.columns, COLUMN_REDUCER_KEYS.list],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getAllComputationsByType({
        metricSetName,
        draftName,
        computationType: ComputationTypes.column,
        offset: 0,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (result) => result.map((r) => r.i),
};
export const loadColumnsEpicReducer = loadResourcesUtils(loadColumnsEpicReducerArg);
const loadColumnDetailsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.COLUMN_DETAILS,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.columns, COLUMN_REDUCER_KEYS.load],
    loadResource: ({ metricSetName, draftName, columnName }, state) => VivaceResoures.getAllComputationsByType({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName,
        draftName,
        computationType: ComputationTypes.column,
        prefix: columnName,
        offset: 0,
    }),
    onCompleteSuccess: (resourceResult) => {
        return resourceResult.length > 0 ? resourceResult[0] : null;
    },
};
export const loadColumnDetailsEpicReducer = loadResourcesUtils(loadColumnDetailsEpicReducerArg);
const loadMetricsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.METRICS_LIST,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, DRAFT_REDUCER_KEYS.metrics, REDUCER_KEYS.draft.metrics.list],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getAllComputationsByType({
        metricSetName,
        draftName,
        computationType: ComputationTypes.metric,
        offset: 0,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (result) => result.map((r) => r.i),
};
export const loadMetricsEpicReducer = loadResourcesUtils(loadMetricsEpicReducerArg);
const loadSegmentsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_LIST,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.segments, SEGMENTS_REDUCER_KEYS.list],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getAllComputationsByType({
        metricSetName,
        draftName,
        computationType: ComputationTypes.segment,
        offset: 0,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const loadSegmentsEpicReducer = loadResourcesUtils(loadSegmentsEpicReducerArg);
const loadSelectedSegmentEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_LOAD,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.segments, SEGMENTS_REDUCER_KEYS.load],
    loadResource: ({ metricSetName, draftName }, state) => VivaceResoures.getAllComputationsByType({
        metricSetName,
        draftName,
        computationType: ComputationTypes.segment,
        offset: 0,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult, inputPayload) => {
        const segment = inputPayload.segment;
        if (!!segment) {
            return resourceResult.find((c) => c.filePath === segment.filePath && c.i['@Name'] === segment.name && c.i['@Level'] === segment.level);
        }
        else {
            return resourceResult.find((c) => c.i['@Name'] === inputPayload.segmentName);
        }
    },
};
export const loadSelectedSegmentEpicReducer = loadResourcesUtils(loadSelectedSegmentEpicReducerArg);
export const removeSegmentsFromList = createAction(ACTION_TYPES.DRAFT.SEGMENTS_REMOVE, (action) => (segmentsToDelete) => action(segmentsToDelete));
export const resetDeleteSegmentState = createAction(ACTION_TYPES.DRAFT.SEGMENTS_RESET_DELETE, (action) => () => action());
const deleteSegmentEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_DELETE,
    customError: (inputPayload, response) => {
        const successfullyDeleted = response.getRawData();
        const failedSegments = inputPayload.segmentsToDelete.filter((s) => !successfullyDeleted.includes(s));
        return {
            displayError: `Failed to delete segments: ${failedSegments.map((s) => "'" + s.name + "'")}. Error: ${response.error} `,
            rawError: failedSegments,
        };
    },
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.segments, SEGMENTS_REDUCER_KEYS.delete],
    loadResource: ({ metricSetName, draftName, segmentsToDelete }, state) => {
        const successfullyDeleted = [];
        const filePathToSegments = {};
        for (var segment of segmentsToDelete) {
            const list = segment.filePath in filePathToSegments ? filePathToSegments[segment.filePath] : [];
            list.push(segment);
            filePathToSegments[segment.filePath] = list;
        }
        return Promise.all(Object.entries(filePathToSegments).map(([k, v]) => VivaceResoures.deleteSegments({
            metricSetName: metricSetName,
            draftName: draftName,
            workspaceId: getWorkspaceIdSelector(state),
            segmentsToDelete: v,
            computationFileName: k,
        }).then((value) => {
            successfullyDeleted.push(...v);
            return value;
        }))).then((value) => RestResult.fromResult(successfullyDeleted, successfullyDeleted.length === segmentsToDelete.length), (value) => RestResult.fromResult(successfullyDeleted, false));
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload) => [removeSegmentsFromList(inputPayload.segmentsToDelete)],
    afterActionsOnFailure: (inputPayload, outputPayload) => [
        removeSegmentsFromList(inputPayload.segmentsToDelete.filter((s) => {
            var _a;
            const failedSegments = ((_a = outputPayload.errorContext) === null || _a === void 0 ? void 0 : _a.rawError) || inputPayload.segmentsToDelete;
            return !failedSegments.includes(s);
        })),
    ],
};
export const deleteSegmentEpicReducer = loadResourcesUtils(deleteSegmentEpicReducerArg);
export const resetCreateSegmentState = createAction(ACTION_TYPES.DRAFT.SEGMENTS_RESET_CREATE, (action) => () => action());
export const addSegmentToList = createAction(ACTION_TYPES.DRAFT.SEGMENTS_ADD, (action) => (segmentToAdd) => action(segmentToAdd));
const putComputationsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_CREATE_PUT,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.segments, SEGMENTS_REDUCER_KEYS.create_put],
    loadResource: ({ metricSetName, draftName, computationFileName, mdlComputations }, state) => VivaceResoures.putMDLComputationFile({
        metricSetName,
        draftName,
        computationFileName,
        workspaceId: getWorkspaceIdSelector(state),
        request: mdlComputations,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload) => {
        Logger.trackEvent({
            name: NewSegmentUITelemetryEventNames.SaveColumnSuccess,
            measurements: {},
            properties: {
                message: `Saved ${inputPayload.isColumn ? 'Column' : 'Segment'} ${inputPayload.segment['@Name']} in computationFile ${inputPayload.computationFileName}`,
            },
        });
        NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
            metricSetName: inputPayload.metricSetName,
            draftName: inputPayload.draftName,
            entityName: inputPayload.isColumn ? MAUIDraftEntityPaths['column'] : MAUIDraftEntityPaths['segment'],
        }));
        const actions = [resetCreateSegmentState()];
        if (!inputPayload.segmentEdit && !inputPayload.isColumn) {
            actions.push(addSegmentToList({ i: inputPayload.segment, filePath: inputPayload.computationFileName }));
        }
        return actions;
    },
};
export const putComputationsEpicReducer = loadResourcesUtils(putComputationsEpicReducerArg);
const createSegmentEpicReducerArg = {
    actionPrefix: ACTION_TYPES.DRAFT.SEGMENTS_CREATE_GET,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.segments, SEGMENTS_REDUCER_KEYS.create_get],
    loadResource: ({ metricSetName, draftName, computationFileName }, state) => VivaceResoures.getMDLComputationFile({
        metricSetName,
        draftName,
        computationFileName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, computationsFile) => {
        var _a;
        const newComputationsFile = addOrUpdateMDLComputationFile(computationsFile, inputPayload.segment, (_a = inputPayload.segmentEdit) === null || _a === void 0 ? void 0 : _a.i, inputPayload.isColumn);
        return [putComputationsEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { mdlComputations: newComputationsFile }))];
    },
};
export const createSegmentEpicReducer = loadResourcesUtils(createSegmentEpicReducerArg);
export const vivaceEpics = combineEpics(loadExperimentationGroupsWithMetricWriteEpicReducer.epic, loadAllExperimentationGroupsEpicReducer.epic, createMetricSetEpicReducer.epic, createMetricSetInstanceEpicReducer.epic, cloneMetricSetEpicReducer.epic, deleteMetricSetEpicReducer.epic, loadMetricSetsEpicReducer.epic, loadMetricSetDraftsEpicReducer.epic, loadMetricSetDraftRawColumnsEpicReducer.epic, loadMetricSetDraftAggregationLevelsEpicReducer.epic, loadMetricSetDraftExperimentationConfigEpicReducer.epic, loadMetricSetDraftMetadataEpicReducer.epic, loadMetricSetDraftHistoryEpicReducer.epic, loadProductionMetaDataEpicReducer.epic, loadScorecardLayoutsEpicReducer.epic, loadComputationTemplatesEpicReducer.epic, loadComputationTemplateInstancesEpicReducer.epic, loadMetricsForCompuatationTemplateInstancesEpicReducer.epic, loadProductionHistoryEpicReducer.epic, createMetricSetDraftEpicReducer.epic, deleteMetricSetDraftEpicReducer.epic, mergeMetricSetDraftEpicReducer.epic, validateMetricSetDraftEpicReducer.epic, getValidateResultEpicReducer.epic, loadMetricSetInstanceStatusEpicReducer.epic, publishMetricSetDraftEpicReducer.epic, loadPublishStatusEpicReducer.epic, loadPublishedVersionsEpicReducer.epic, loadRecentPreviewAnalysisEpicReducer.epic, loadExperimentEpicReducer.epic, loadRecentExperimentsEpicReducer.epic, loadFeatureProgressionsEpicReducer.epic, loadRecentFeaturesEpicReducer.epic, loadDefaultExperimentsEpicReducer.epic, loadDefaultFeaturesEpicReducer.epic, loadFeaturesForExperimentationGroupEpicReducer.epic, loadExperimentsForExperimentationGroupEpicReducer.epic, checkUserMetricWriteAccessEpicReducer.epic, draftMetricsQueryStringEpics, loadMetricHealthResultsEpicReducer.epic, loadSubscribersEpicReducer.epic, loadWorkspaceConfigEpicReducer.epic, loadMetricSetConfigEpicReducer.epic, loadMetricSetMainAggregationLevelsEpicReducer.epic, SetSubscribersEpicReducer.epic, loadSegmentsEpicReducer.epic, deleteSegmentEpicReducer.epic, loadComputationFilePathsEpicReducer.epic, loadColumnsEpicReducer.epic, loadColumnDetailsEpicReducer.epic, loadMetricsEpicReducer.epic, createSegmentEpicReducer.epic, putComputationsEpicReducer.epic, loadSelectedSegmentEpicReducer.epic, updateMetricSetConfigEpicReducer.epic, loadExperimentStepPlanSummariesEpicReducer.epic, validateExperimentStepsEpicReducer.epic, updateMergeStatusMetricSetDraftEpicReducer.epic, updatePublishStatusMetricSetDraftEpicReducer.epic);

//# sourceMappingURL=Vivace.epics.js.map
